import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import classNames from 'classnames';

import { getMenuItems } from 'helpers';
import AppMenu from './Menu/';

import { profileMenus, 
  //notifications, searchOptions 
} from './Topbar/data';

// Imagens
import logoSm from 'assets/images/logo_sm.png';
import logoDark from 'assets/images/logo-dark.png';
import logoDarkSm from 'assets/images/logo_sm_dark.png';
import logo from 'assets/images/logo.png';
import helpBoxImage from 'assets/images/help-icon.svg';
import profileImg from 'assets/images/users/avatar-1.jpg';
import vila_logo_sf from 'assets/images/vilasoftwarelogo_branca.png';

import ProfileDropdown from './Profile/ProfileDropdown';

type SideBarContentProps = {
  hideUserProfile: boolean;
};

const SideBarContent = ({ hideUserProfile }: SideBarContentProps) => {
  return <AppMenu />;
};

const SideBarProfile = () => {
  return (
    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
      <ProfileDropdown />
    </div>
  );
};

type LeftSidebarProps = {
  hideLogo?: boolean;
  hideUserProfile: boolean;
  isLight: boolean;
  isCondensed: boolean;
};

const LeftSidebar = ({
  isCondensed,
  isLight,
  hideLogo,
  hideUserProfile,
}: LeftSidebarProps) => {
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const sidebar = document.querySelector<HTMLDivElement>('.leftside-menu');
      if (!sidebar?.contains(e.target as Node)) {
        // Use requestAnimationFrame para evitar ResizeObserver loop
        requestAnimationFrame(() => {
          document.body.classList.remove('sidebar-enable');
        });
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="leftside-menu container-fluid">
      {!hideLogo && (
        <>
          {/* Logo Light */}
          <Link to="/" className="logo text-center logo-light">
            <span className="logo-lg" style={{ textAlign: 'center' }}>
              <img src={vila_logo_sf} alt="logo" height="60" style={{ maxHeight: '60px' }} />
            </span>
            <span className="logo-sm">
              <img src={logoSm} alt="logo" height="40" style={{ maxHeight: '60px' }} />
            </span>
          </Link>

          {/* Logo Dark */}
          <Link to="/" className="logo text-center logo-dark">
            <span className="logo-lg">
              <img src={vila_logo_sf} alt="logo" height="60" />
            </span>
            <span className="logo-sm">
              <img src={vila_logo_sf} alt="logo" height="40" />
            </span>
          </Link>
        </>
      )}

      {!isCondensed ? (
        <SimpleBar
          style={{ maxHeight: 'calc(100vh - 120px)' }}
          scrollbarMaxSize={320}
        >
          <SideBarContent hideUserProfile={hideUserProfile} />
        </SimpleBar>
      ) : (
        <SideBarContent hideUserProfile={hideUserProfile} />
      )}

      <div></div>

      <SideBarProfile />
    </div>
  );
};

export default LeftSidebar;
